<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary white--text headline">
                    {{'Data Export'|translate}}
                    <v-spacer></v-spacer>
                    <date-range-selector v-model="range"></date-range-selector>
                </v-card-title>
                <v-card-text>
                    <query-builder v-model="query"></query-builder>
                    <v-checkbox 
                      v-model="includeTimestamp"
                      label="Include the timestamp 00:00:00"
                      class="ml-4"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-layout row>
                        <v-spacer></v-spacer>
                        <v-btn class="secondary" @click="viewData" :disabled="!query">{{'View Data'|translate}}</v-btn>
                        <v-btn class="secondary mr-4" @click="downloadCSV" :disabled="!tsLength">{{'Download CSV'|translate}}</v-btn>
                    </v-layout>
                </v-card-actions>
                <v-card-text>
                    <loading-progress-bar :loading="loading" v-if="loading"></loading-progress-bar>
                    <div style="overflow: auto">
                    <table>
                        <tr>
                            <!-- header row -->
                            <td v-for="(m,k) in df" style="font-weight: bold; padding: 12px;">
                                {{k}}
                            </td>
                        </tr>
                        <tr v-for="(j,i) in df['timestamp']" v-if="i<end&&i>=start">
                            <td v-for="(m,k) in df" style="padding: 12px;">
                                {{m[i]}}
                            </td>
                        </tr>
                    </table>
                    </div>
                    <!-- Display Data as table -->
                </v-card-text>
                <v-pagination v-show="df['timestamp']"
                        v-model="pageNumber"
                        :length="tsLength"
                ></v-pagination>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import DateRangeSelector from '../components/DateRangeSelector'
  import LoadingProgressBar from '../components/LoadingProgressBar'
  import {callAPI} from '@/helper'
  import {exportCSVFromDicts} from "@/tocsv.js"
  import moment from 'moment'
  import QueryBuilder from "./QueryBuilder";

  export default {
    name: 'ViewData',
    components: { LoadingProgressBar, DateRangeSelector,QueryBuilder },
    data () {
      return {
          equipment_name: null,
          range: {start: moment().subtract(1, "days").format("YYYY-MM-DD"), end: moment().format("YYYY-MM-DD")},
          loading: false,
          pageSize: 50,
          pageNumber: 1,
          query:null,
          df: {},
          includeTimestamp: false    // updated
      }
    },
    computed: {
        start(){
            return (this.pageNumber-1) * this.pageSize;
        },
        end(){
            return this.start + this.pageSize;
        },
        tsLength(){
            if(!this.df['timestamp']){
                return 0;
            }
            return Math.ceil(this.df['timestamp'].length/this.pageSize)
        },
      facility_name () {
        return this.$store.state.pointsListStore.pointsList.facility_name
      },
    },
    methods: {
        async viewData() {
            this.pageNumber = 1;
            this.loading = true
            if (this.query && this.facility_name && this.range) {
                let query=JSON.parse(JSON.stringify(this.query))
                query.filters.facility_name=this.facility_name
                // query.date_range=[this.range.start,this.range.end+" 23:59:59"]
                let endDate;
                if (this.includeTimestamp) {
                  endDate = moment(this.range.end).add(1, 'day').format('YYYY-MM-DD') + ' 00:00:00';
                } else {
                  endDate = this.range.end + ' 23:59:59';
                }
                query.date_range = [this.range.start, endDate];
                let df= await callAPI('data3/',query)
                this.df=df.data
            }
            this.loading = false
        },
        async downloadCSV() {
            await this.viewData()
            exportCSVFromDicts(this.df)
        }
    },
      beforeMount() {
          let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
          if (maxDate) {
              this.range = {
                  start: moment(maxDate).subtract(1, "days").format('YYYY-MM-DD'),
                  end: moment(maxDate).format('YYYY-MM-DD')
              }
          }
      }
  }
</script>

<style scoped>
    table {
  border-collapse: collapse;
}

table, th, td {
  border: 1px solid black;
}

</style>
